import { LoaderCircle, ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function Login() {
  const { authenticated, login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (authenticated) return <Navigate to="/app" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(username, password);
    } catch (exception) {
      setError(exception.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <header>
          <span className="product-mark"><ShieldCheck size={24} /></span>
          <div><h1>DDoS Cluster</h1><p>Control plane</p></div>
        </header>
        <form onSubmit={submit}>
          <label>Username<input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" required autoFocus /></label>
          <label>Password<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required /></label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button button-primary button-wide" type="submit" disabled={busy}>
            {busy && <LoaderCircle className="spin" size={16} />}Sign in
          </button>
        </form>
      </section>
    </main>
  );
}
